import React, {Component} from 'react';
import {Router, Route} from 'react-router-dom';
import CookieBanner from 'react-cookie-banner';
import Analytics from 'react-router-ga';
import history from './history';
import './App.css';
import Navigation from './navigation/Navigation';
import Footer from './footer/Footer';
import Home from './pages/home/Home';
import SpeakersPage from './pages/speakers/SpeakersPage';
import TalksPage from "./pages/talks/TalksPage";
import Registration from "./pages/registration/RegistrationPage";
import {GettingAroundPage, HotelsPage, InformationPage, VenuePage} from "./pages/information/InformationPage";
import {AboutPage} from "./pages/information/About";
import {showSpeakers} from './config';
import {showAgenda} from './config';
import {CodeOfConduct} from "./pages/information/coc/CodeOfConduct";
import {TheCrewPage} from "./pages/information/crew/TheCrewPage";
import {ImpressionsPage} from "./pages/information/impressions/ImpressionsPage";
import ScrollToTop from "./components/helpers/ScrollToTop";
import Sponsors from "./pages/sponsors/SponsorsPage";
import {gaId, tawkIoToken} from './config';
import AgendaPage from "./pages/agenda/AgendaPage";
import TawkIO from "./components/TawkIO";
import ConfRatingPage from "./pages/rating/ConfRatingPage";

class App extends Component {
    render() {
        return (
            <div>
                <Router history={history}>
                    <Analytics id={gaId} debug>
                        <ScrollToTop>
                            <TawkIO token={tawkIoToken}/>
                            <div className="App">
                                <Navigation/>
                                <div>
                                    <Route path="/" exact component={Home}/>
                                    <Route path="/registration" component={Registration}/>
                                    {showAgenda &&
                                    <Route path="/agenda" component={AgendaPage}/>
                                    }
                                    {showSpeakers &&
                                    <Route path="/speakers" component={SpeakersPage}/>
                                    }
                                    {showSpeakers &&
                                    <Route path="/talks" component={TalksPage}/>
                                    }
                                    <Route path="/information" component={InformationPage}/>
                                    <Route path="/venue" component={VenuePage}/>
                                    <Route path="/hotels" component={HotelsPage}/>
                                    <Route path="/getting-around" component={GettingAroundPage}/>
                                    <Route path="/impressions" component={ImpressionsPage}/>
                                    <Route path="/code-of-conduct" component={CodeOfConduct}/>
                                    <Route path="/about" component={AboutPage}/>
                                    <Route path="/crew" component={TheCrewPage}/>
                                    <Route path="/sponsors" component={Sponsors}/>
                                    <Route path="/rating" component={ConfRatingPage}/>
                                    <CookieBanner
                                        message="Cookie policy: Yes, we use them to track your visit. Nothing personal though!"
                                        onAccept={() => {
                                        }}
                                        cookie="user-has-accepted-cookies"
                                        dismissOnScrollThreshold={100}
                                        styles={{banner: {position: 'absolute', bottom: 0}, button: {right: 100}}}/>
                                </div>
                            </div>
                        </ScrollToTop>
                    <Footer/>
                    </Analytics>
                </Router>
            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js